export default __webpack_public_path__ + "static/media/Abrar.82250597.png";